import React, {Component} from "react";
import {Button, Container, Form, Grid, Icon, Input, Modal, Popup} from "semantic-ui-react";

export class JoinSessionModal extends Component {
    constructor(props) {
        super(props);
        this.publicId = null;
        this.privateId = null;
        this.state = {
            step: 1,
            mode: '',
            modalOpened: false,
            showExplanation: null
        }
    }

    asEditor = () => {
        this.setState({
            step: 2,
            mode: 'editor',
            showExplanation: null
        })
    };

    asObserver = () => {
        this.setState({
            step: 2,
            mode: 'observer',
            showExplanation: null
        })
    };

    handleChange = (e, {value}) => {
        this.publicId = value.trim();
    };
    handleChangePrivate = (e, {value}) => {
        this.privateId = value.trim();
    };

    showObserverExplanation() {
        this.setState({
            showExplanation: 'observer'
        })
    }

    showEditorExplanation() {
        this.setState({
            showExplanation: 'editor'
        })
    }

    hideExplanation() {
        this.setState({
            showExplanation: null
        })
    }

    buildTitle() {
        if (this.state.step === 1) {
            return 'Join existing session';
        }
        return 'Join session as ' + this.state.mode;
    }

    render() {
        const {step, mode, modalOpened, showExplanation} = this.state;
        const {popUpText} = this.props;
        const title = this.buildTitle();
        return (
            <React.Fragment>
                <Popup trigger={<Button onClick={() => {
                    this.setState({modalOpened: true})
                }}>Join existing remote session</Button>}
                       content={popUpText}/>
                <Modal open={modalOpened} onClose={() => {
                    this.setState({modalOpened: false})
                }}>
                    <Modal.Header>{step === 2 &&
                    <Icon className={"biggerOnHover"} size="large" style={{float: 'left', cursor: 'pointer'}}
                          name='arrow alternate circle left outline'
                          onClick={() => this.setState({step: 1})}/>}{title}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {step === 1 &&
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column textAlign="center">
                                        <Button onMouseOver={() => this.showObserverExplanation()}
                                                onMouseOut={() => this.hideExplanation()}
                                                onClick={() => this.asObserver()} size={'big'} circular>As an
                                            observer</Button>
                                        <Button
                                            onMouseOver={() => this.showEditorExplanation()}
                                            onMouseOut={() => this.hideExplanation()}
                                            onClick={() => this.asEditor()}
                                            size={'big'}
                                            circular>As an
                                            editor</Button>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column textAlign="center">
                                        {showExplanation === null && <blockquote>&nbsp;</blockquote>}
                                        {showExplanation === 'observer' &&
                                        <blockquote>In observer mode, you can view the content of the session but not
                                            change
                                            any content.</blockquote>}
                                        {showExplanation === 'editor' &&
                                        <blockquote>In editor mode, you can view and edit the content of the
                                            session.</blockquote>}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>}
                            {step === 2 && <Container textAlign="center">
                                <Form>

                                    {mode === 'observer' && <Grid textAlign='center'>
                                        <Grid.Row>
                                            <Input style={{width: '70%'}}
                                                   placeholder='Public session id'
                                                   onChange={this.handleChange.bind(this)}/>

                                        </Grid.Row>
                                        <Grid.Row>
                                            <Button style={{marginTop: "20px"}}
                                                    onClick={() => this.props.onSubmit({"sessionIdPublic": this.publicId})}
                                                    content={"join"}/>
                                        </Grid.Row>
                                    </Grid>
                                    }
                                    {mode === 'editor' && <Grid textAlign='center'>
                                        <Grid.Row>
                                            <Input style={{width: '70%'}}
                                                   placeholder='Private session id'
                                                   onChange={this.handleChangePrivate.bind(this)}/>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Button style={{marginTop: "20px"}}
                                                    onClick={() => this.props.onSubmit({"sessionIdPrivate": this.privateId})}
                                                    content={"join"}/>
                                        </Grid.Row>
                                    </Grid>
                                    }
                                </Form>
                            </Container>
                            }
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </React.Fragment>
        )
    }
}